import { PropsWithChildren } from 'react';

import css from './styles.module.css';

/** Controls aligned to the far end of the header. */
export function HeaderActions({ children }: PropsWithChildren) {
  return <div className={css.actions}>{children}</div>;
}
